module.exports = __webpack_public_path__ + "dash_20_app_assets/img/card-image-5.677b3fc1.jpg";